import { AiContentDownloadEvent } from '@videoblocks/events-ts/lib/storyblocks/content/ai/AiContentDownloadEvent';

import { AiContentEventCommonOptions, buildCommonAiContentEventProperties } from './AiContentEventCommon';

export type AiContentDownloadEventFactoryOptions = AiContentEventCommonOptions;

async function create(options: AiContentDownloadEventFactoryOptions): Promise<AiContentDownloadEvent> {
    const event = new AiContentDownloadEvent();

    // most of the event properties are shared between the ai content events
    const commonProps = await buildCommonAiContentEventProperties(options);
    Object.assign(event, commonProps);

    return event;
}

export const AiContentDownloadEventFactory = { create };
